import { render, staticRenderFns } from "./FiltersLunchControl.vue?vue&type=template&id=3e1dac7e"
import script from "./FiltersLunchControl.vue?vue&type=script&lang=ts"
export * from "./FiltersLunchControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports